import { BrowserRouter, useRoutes } from "react-router-dom";

import { Toaster } from "@/components/_atoms/sonner";

import { publicEmbedRoutes } from "./public-embed.routes";

function InnerPublicEmbedRouter() {
  const routing = useRoutes(publicEmbedRoutes);

  return routing;
}

export function PublicEmbedRouter() {
  return (
    <BrowserRouter>
      <InnerPublicEmbedRouter />
      <Toaster />
    </BrowserRouter>
  );
}
